<div class="card mb-5">
	<div class="card-header">
		<h3>Notas de Ingreso 
            <span (click)="createNote = true;">
                <i style="font-size: 0.8em;" class="a-hover fa fa-plus">
                    <span style="font-family: 'Nunito', sans-serif;">CREAR NOTA DE INGRESO</span>
                </i>
            </span>
        </h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<div class="row" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Filtrar</label>
						<div class="input-group input-group-sm">
							<input type="text" id="filter" (input)="searching()" [(ngModel)]="filterWord"
								placeholder="Filtra nota por numero" name="filter" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="table-responsive" style="margin-bottom: 0;">
					<table class="table table-bordered" style="margin-bottom: 0; margin-top: 1em;">
						<thead>
							<tr>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Proveedor
								</th>
								<th class="ta">
									Fecha de Ingreso
								</th>
								<th class="ta">
									Fecha que se Recibió
								</th>
								<th class="ta">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let note of pagination.filter">
								<tr>
									<td class="ta">
										{{note.noteNumber}}
									</td>
									<td class="ta">
										{{note.providerData ? note.providerData.name:"" }}
									</td>
									<td class="ta">
										{{convertToString(note.entryDate)}}
									</td>
									<td class="ta">
                                        {{ note.entryDate | date:'yyyy-MM-dd HH:MM' }}
									</td>
									<td class="ta" >
										<div style="display: flex; justify-content: center;">
											<div class="container-superposition">
												<span (click)="showDetails(note)" class="a-hover" tooltip="Ver Detalles">
                                                    <i
                                                        class="fa fa-eye span-hover text-primary"
                                                    ></i>
                                                </span>
                                                <span (click)="downloadNote(note)" class="download-receipt" tooltip="Descargar">
                                                    <i class="clickeable text-info fa fa-receipt span-hover text-primary"></i>
                                                </span>
                                                
                                                
                                                <div
                                        class="container-superposition"
                                        title="Eliminar"
                                        tooltip="Eliminar"
                                    >
                                        <div
                                            class="element-superposition"
                                            *ngIf="waitingFor?.id == note.id"
                                        >
                                            <span
                                                >¿Está seguro que desea Eliminar
                                                esta orden?</span
                                            >
                                            <span class="a-container">
                                                <span class="a-hover" (click)="resetDeletingDiv()"
                                                    ><i class="fa fa-ban"></i
                                                    >NO</span
                                                >
                                                <span class="a-hover text-danger" (click)="confirmDelete(note)">
                                                    <i class="fa fa-check"></i>
                                                    SÍ
                                                </span>
                                            </span>
                                        </div>
                                        <span
                                            class="clickeable text-danger span-hover"
                                            (click)="deleteNote(note)"
                                        >
                                            <i
                                                *ngIf="!deleting[note.id]"
                                                class="fa fa-xmark-circle"
                                            ></i>
                                            <span
                                                *ngIf="deleting[note.id]"
                                                class="spinner-border spinner-border-sm"
                                                aria-hidden="true"
                                            ></span>
                                        </span>
                                </div>

											</div>
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se tiene notas de ingreso registradas.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>
<app-create-entry-note *ngIf="createNote" [showModal]="createNote" (closed)="closeCreateNote($event)"/>



<app-entry-note-details 
    *ngIf="entryNote != null"
    [showModal]="entryNote != null"
    [noteId]="showDetailsId"
    [note]="entryNote" 
    (closed)="closeDetails()"
></app-entry-note-details>